const appConfig = {

	footer: {
		htmlText: '<small>© <b>KB Solutions srl</b>. All Rights Reserved.</small>',
		cssClass: 'px-3 py-2 bggi-black text-muted'
	}
}
export default appConfig